import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Grid,
} from "@material-ui/core";
import { toast } from 'react-hot-toast';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    message: "",
  });

  const [formValid, setFormValid] = useState(false);
  const [pending, setPending] = useState(false);

  const formSubmitEndpoint = `https://formsubmit.co/${process.env.REACT_APP_CONTACT_EMAIL}`; // Replace with your Gmail

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    const { name, company, email, message } = formData;
    const isValid =
      name.trim() &&
      company.trim() &&
      message.trim() &&
      validateEmail(email);
    setFormValid(isValid);
  }, [formData]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    setPending(true);
    e.preventDefault();

    try {
      const formPayload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formPayload.append(key, value);
      });
      formPayload.append("_subject", "New message from showNAV contact form");
      formPayload.append("_captcha", "false");

      const res = await fetch(formSubmitEndpoint, {
        method: "POST",
        body: formPayload,
      });

      if (res.ok) {
        toast.success("Message sent successfully!");
        setFormData({ name: "", company: "", email: "", message: "" });
        setPending(false);
      } else {
        toast.error("Failed to send message. Please try again.");
        setPending(false);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
      setPending(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <form onSubmit={handleSubmit} style={{ marginTop: "1rem" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              name="name"
              label="Name"
              fullWidth
              required
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              name="company"
              label="Company"
              fullWidth
              required
              value={formData.company}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              name="email"
              label="Email"
              fullWidth
              required
              type="email"
              value={formData.email}
              onChange={handleChange}
              error={!!formData.email && !validateEmail(formData.email)}
              helperText={
                !!formData.email && !validateEmail(formData.email)
                  ? "Enter a valid email"
                  : <></>
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              name="message"
              label="Message"
              fullWidth
              required
              multiline
              rows={4}
              value={formData.message}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={!formValid || pending}
            >
              {pending ? 'Sending...' : 'Send'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default ContactForm;
